import { Outlet } from '@/util/react-router-dom';
import { EncounterProvider } from '@/contexts/encounter-context';
import { SurrogateI18nProvider } from '@/contexts/i18n-context';

export function EncounterOutlet() {
  return (
    <EncounterProvider>
      <SurrogateI18nProvider source="encounter">
        <Outlet />
      </SurrogateI18nProvider>
    </EncounterProvider>
  );
}
